import { getAPIHost, getAppToken, getLoginToken } from '../../ui/utils/helper';
import { isTokenValid, doLogout } from '../../ui/utils/auth';
import { LoggerService } from '../../ui/utils';

async function customFetch(url: string, options?: RequestInit): Promise<Response> {
  const loginToken: string | null = getLoginToken();
  const appToken: string | null = getAppToken();

  if (!options) {
    options = {};
  }

  // eslint-disable-next-line
  const serviceHeaders: any = {};

  if (loginToken) {
    serviceHeaders['x-app-token'] = loginToken;
  }
  if (appToken) {
    if (isTokenValid(appToken)) {
      // with valid token time
      serviceHeaders['x-access-token'] = appToken;
    } else {
      doLogout();
      window?.location?.reload();
      throw new Error('Token invalid');
    }
  }

  try {
    let baseUrl = getAPIHost() ?? '';
    baseUrl = `${baseUrl}/`;

    const response = await fetch(`${baseUrl}${url}`, {
      ...options,
      headers: {
        ...options.headers,
        ...serviceHeaders,
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized');
      }
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Check if response status is 204
    if (response.status === 204) {
      // patch the message for 204
      const returnMessage = response.headers.get('return-message');
      const data = { returnMessage };
      return { ...response, data } as Response;
    }

    return response;
  } catch (error) {
    LoggerService.log('Error customFetch', error);
    throw new Error((error as Error)?.message || 'Network error');
  }
}

export default customFetch;
